// vuex/modules/file/store.js
//import Config from "../config"

let Config = {}
try {
  Config = require("/config.js").default
} catch (err) {
  console.log("SessionManager: Couldn't find module config, using adc-web-components config")
  Config = require("/config.js").default
}

const SessionManager = {
  namespaced: true,
  state: {
    DEBUG: false,
    expiration: null,
    warningCount: 0,
    timeout: null,
  },
  getters: {
    isExpired: (state) => {
      return state.expiration === null || Date.parse(state.expiration) <= (new Date())
    },
  },
  mutations: {
    sessionExpired(state) {
      if (state.DEBUG) console.log("[Mutation] SessionManager.sessionExpired")
      // Handle Session Management
      state.expiration = null
      state.timeout = null
    },
    incrementWarningCount(state) {
      if (state.DEBUG) console.log("[Mutation] SessionManager.sessionExtend warning timeout triggered")
      state.warningCount++
    },
    sessionExtend(state, timeoutId) {
      if (state.DEBUG) console.log("[Mutation] SessionManager.sessionExtend")
      state.expiration = new Date()
      state.expiration.setMinutes( state.expiration.getMinutes() + Config.session.sessionExpirationMinutes )
      state.timeout = timeoutId
    },
  },
  actions: {
    logout: ({state, commit, dispatch}) => {
      if (state.DEBUG) console.log("[Action] SessionManager.logout")
      // Handle Auth Service
      if (Config.session.authService) {
        dispatch("AuthService/logout", {}, { root: true })
      }

      // Handle GraphQL
      if (Config.session.graphQL) {
        dispatch("GraphQL/logout", {}, { root: true })
      }

      clearTimeout(state.timeout)
      commit("sessionExpired")
    },
    checkSession: ({state, dispatch}) => {
      if (state.DEBUG) console.log("[Action] SessionManager.checkSession")
      if (state.expiration !== null && Date.parse(state.expiration) <= (new Date())) {
        dispatch("logout")
      }
    },
    newSession: ({state, commit}) => {
      if (state.DEBUG) console.log("[Action] SessionManager.newSession")
      clearTimeout(state.timeout)
      const timeoutId = setTimeout(() => {
        commit("incrementWarningCount")
      }, 1000*60*Config.session.sessionWarningMinutes)
      commit("sessionExtend", timeoutId)
    },
    extendSession:  ({dispatch, commit, state}) => {
      if (state.DEBUG) console.log("[Action] SessionManager.extendSession")
      if (state.expiration === null || Date.parse(state.expiration) <= (new Date())) {
        dispatch("logout")
      } else {
        clearTimeout(state.timeout)
        const timeoutId = setTimeout(() => {
          commit("incrementWarningCount")
        }, 1000*60*Config.session.sessionWarningMinutes)
        commit("sessionExtend", timeoutId)
      }
    },
  },
}

export default SessionManager
